<template>
    <div class="slide-left fs-14">
        <router-link :to="'/home'">
            <div class="slide-logo">
                <img src="../assets/logo.png" height="40px" alt="" style="vertical-align: middle;">
            </div>
        </router-link>
        <el-scrollbar>
            <div class="slide" :key="index + 1" v-for="(slide, index) in slide_lists">
                <el-tooltip class="tooltip-item" effect="dark" :content="slide.title" placement="right">
                    <div class="slide-title" :key="index + 1" @click="shrinkLists(index)"><i class="ico-home3 d-i-b"></i><span v-text="slide.title"></span></div>
                </el-tooltip>
                <ul class="slide-lists" :class="{'shrink-lists':slide.shrink_lists}">
                    <router-link :to="'/' + list.url" :key="list.id" class="router-link" v-for="list in slide.lists">
                        <el-tooltip class="tooltip-item" effect="dark" :content="list.title" placement="right">
                            <li class="slide-list" :key="list.id"><i :class="list.i" class="d-i-b"></i><span v-text="list.name"></span></li>
                        </el-tooltip>
                    </router-link>
                </ul>
            </div>
        </el-scrollbar>
        <div class="slide-help"><i class="el-icon-service"></i></div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                slide_lists:[
                    {
                        title:'element-ui',
                        shrink_lists:false,
                        lists:[
                            {
                                id:1,
                                name:'layout',
                                url:'layout',
                                i:'ico-menu4',
                                title:'栅格'
                            },
                            {
                                id:2,
                                name:'form',
                                url:'form',
                                i:'ico-file',
                                title:'表单'
                            },
                            {
                                id:3,
                                name:'container',
                                url:'container',
                                i:'ico-grid',
                                title:'布局'
                            },
                            {
                                id:4,
                                name:'icon',
                                url:'icon',
                                i:'el-icon-info',
                                title:'图标'
                            },
                            {
                                id:5,
                                name:'upload',
                                url:'upload',
                                i:'ico-upload',
                                title:'上传'
                            },
                            {
                                id:6,
                                name:'star&tag&progress',
                                url:'star-tag-progress',
                                i:'ico-star',
                                title:'星级 标签 进度条'
                            },
                            {
                                id:7,
                                name:'colorPicker&tree',
                                url:'colorPicker-tree',
                                i:'ico-tree',
                                title:'取色板 树形结构'
                            },
                            {
                                id:8,
                                name:'transfer',
                                url:'transfer',
                                i:'ico-exchange',
                                title:'穿梭框'
                            },
                            {
                                id:9,
                                name:'table',
                                url:'table',
                                i:'ico-table',
                                title:'表格'
                            },
                            {
                                id:10,
                                name:'message',
                                url:'message',
                                i:'ico-notification2',
                                title:'提示'
                            },
                            {
                                id:11,
                                name:'card&carousel&collapse', 
                                url:'card-carousel-collapse',
                                i:'ico-vcard',
                                title:'卡片 轮播 折叠版'
                            },
                        ]
                    },
                    {
                        title:'vue插件',
                        shrink_lists:false,
                        lists:[
                            {
                                id:12,
                                name:'editor',
                                url:'editor',
                                i:'ico-edit-sign',
                                title:'富文本编辑器'
                            },
                            {
                                id:13,
                                name:'amap', 
                                url:'map',
                                i:'ico-map',
                                title:'百度地图'
                            },
                            {
                                id:14,
                                name:'vue-baidu-map', 
                                url:'vue-baidu-map',
                                i:'ico-map',
                                title:'百度地图'
                            },
                            {
                                id:15,
                                name:'vue-form', 
                                url:'vue-form',
                                i:'ico-file8',
                                title:'vue-form'
                            },
                            {
                                id:16,
                                name:'v-lazy', 
                                url:'vue-lazyload',
                                i:'ico-picture',
                                title:'vue-lazyload'
                            },
                            {
                                id:17,
                                name:'vue-cropper', 
                                url:'vue-cropper',
                                i:'ico-crop2',
                                title:'VueCropper'
                            },
                            {
                                id:18,
                                name:'vue-scrollbar', 
                                url:'vue-scrollbar',
                                i:'ico-screen',
                                title:'vue-scrollbar'
                            },
                            {
                                id:19,
                                name:'vue-scroller', 
                                url:'vue-scroller',
                                i:'ico-mobile',
                                title:'移动端vue-scroller'
                            },
                            {
                                id:20,
                                name:'vue-awesome-swiper', 
                                url:'vue-awesome-swiper',
                                i:'ico-cube4',
                                title:'vue-awesome-swiper'
                            }
                        ]
                    },
                    {
                        title:'vue',
                        shrink_lists:false,
                        lists:[
                            {
                                id:21,
                                name:'vue-slot', 
                                url:'vue-slot',
                                i:'ico-link',
                                title:'vue-slot 插槽'
                            },
                            {
                                id:22,
                                name:'transfer-value', 
                                url:'transfer-value',
                                i:'ico-arrow3',
                                title:'同级组件传值'
                            },
                            {
                                id:23,
                                name:'router&keyCode', 
                                url:'home',
                                i:'ico-link',
                                title:'子路由 路由传值 键盘事件'
                            },
                            {
                                id:24,
                                name:'loading', 
                                url:'loading-model',
                                i:'ico-spinner2 rotate_active_n',
                                title:'loading'
                            },
                            {
                                id:25,
                                name:'svg', 
                                url:'svg',
                                i:'ico-spinner2',
                                title:'svg'
                            },
                            {
                                id:26,
                                name:'color&copy', 
                                url:'color',
                                i:'ico-palette',
                                title:'color&copy'
                            },
                            {
                                id:27,
                                name:'monaco-editor', 
                                url:'monaco-editor',
                                i:'ico-palette',
                                title:'monaco-editor'
                            },
                        ]
                    },
                ],
            }
        },
        methods:{
            shrinkLists(i){
                this.slide_lists[i].shrink_lists = !this.slide_lists[i].shrink_lists;
            }
        }
    }
</script>
<style module>
</style>
<style scoped>
    .slide-logo{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
    }
    .router-link{
        display: block;
    }
    .el-scrollbar {
        width: 100%;
        height: 100%;
    }
    .slide-left{
        flex: 0 0 240px;
        height: 100%;
        overflow: hidden;
        transition: all 300ms;
        padding: 50px 0 80px;
        position: relative;
    }
    .main.close .slide-left{
        flex:0 0 40px;
    }
    .slide-title{
        width: 100%;
        height: 30px;
        font-size: 13px;
        color: #aaa;
        line-height: 30px;
        padding-left: 30px;
        cursor: pointer;
        position: relative;
    }
    .slide-title span{
        opacity: 1;
        transition: opacity 500ms;
    }
    .slide-lists{
        width: 100%;
        height: auto;
        overflow: hidden;
        transition: height 500ms;
    }
    .shrink-lists{
        height: 0!important;
    }
    .slide-list{
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding-left: 30px;
        position: relative;
    }
    .slide-title > i, .slide-list > i{
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        vertical-align: middle;
    }
    .slide-left span{
        opacity: 1;
        transition: all 500ms;
    }
    .main.close .slide-list > span {
        opacity: 0;
    }
    .main.close .slide-title > span {
        opacity: 0;
    }

    .slide-lists li{
        transition: all 300ms;
    }
    .slide-help{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 80px;
        text-align: center;
        line-height: 80px;
        font-size: 40px;
        color: #fff;
    }

    .slide-left-dark .slide-left{
        background: var(--slide-b-dark);
    }
    .slide-left-leight .slide-left{
        background: var(--slide-b-leight);
    }
    .slide-left-dark .slide-left .slide-list{
        color: #eee;
    }
    .slide-left-leight .slide-left .slide-list{
        color: #192539;
    }
    .slide-left-dark .slide-left li:hover {
        color: #fff;
        background: rgba(255,255,255,0.1);
    }
    .slide-left-leight .slide-left li:hover {
        color: #333;
        background: rgba(51,51,51,0.1);
    }
    /* 当前页面左侧列表变色 */
    .slide-left-dark .router-link-exact-active li {
        color: #fff;
        background: rgba(255,255,255,0.1);
    }
    .slide-left-leight .router-link-exact-active li {
        color: #fff;
        background: rgba(51,51,51,0.1);
    }
    .slide-left-leight .slide-left .slide-help{
        color: var(--slide-b-leight);
    }
    .slide-left-leight .slide-left .slide-help{
        color: var(--slide-b-dark);
    }
</style>


// WEBPACK FOOTER //
// src/components/slide-left.vue